<template>
    <div class="phone-input">
        <!-- <div class="taipei">
            <div class="taipei-num">
                <i class="el-icon-phone-outline"></i>
                <span>( 北 ) 0938-393-011</span>
            </div>
        </div>
        <div class="taizhong">
            <div class="taipei-num">
                <i class="el-icon-phone-outline"></i>
                <span>( 中 ) 0909-593-777</span>
            </div>
        </div>
        <div class="gaoxiong">
            <div class="taipei-num">
                <i class="el-icon-phone-outline"></i>
                <span>( 南 ) 0938-616-686</span>
            </div>
        </div> -->
        <div class="taipei">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-phone-outline"></i>
                <transition name="fade">
                    <a href="tel:0909853777" v-if="show">台北 / 0909-853-777</a>
                </transition>
            </div>
        </div>
        <div class="gaoxiong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-phone-outline"></i>
                <transition name="fade">
                    <a href="tel:0938316568" v-if="show">桃園 / 0938-316-568</a>
                </transition>
            </div>
        </div>
        <div class="taizhong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-phone-outline"></i>
                <transition name="fade">
                    <a href="tel:0909593777" v-if="show">台中 / 0909-593-777</a>
                </transition>
            </div>
        </div>
        <div class="gaoxiong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-phone-outline"></i>
                <transition name="fade">
                    <a href="tel:0938393011" v-if="show">高雄 / 0938-393-011</a>
                </transition>
            </div>
        </div>
        <!-- orcode line -->
        <div class="gaoxiong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-chat-dot-square"></i>
                <transition name="fade">
                    <a href="https://line.me/ti/p/aXkId8b5fr" v-if="show">台北 / LINE</a>
                </transition>
            </div>
        </div>
        <div class="gaoxiong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-chat-dot-square"></i>
                <transition name="fade">
                    <a href="https://line.me/ti/p/iEu-ooEX4j" v-if="show">桃園 / LINE</a>
                </transition>
            </div>
        </div>
        <div class="gaoxiong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-chat-dot-square"></i>
                <transition name="fade">
                    <a href="https://line.me/ti/p/WRn1IWqktp" v-if="show">台中 / LINE</a>
                </transition>
            </div>
        </div>
        <div class="gaoxiong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-chat-dot-square"></i>
                <transition name="fade">
                    <a href="https://line.me/ti/p/YP0AiXUirU" v-if="show">高雄 / LINE</a>
                </transition>
            </div>
        </div>
        <div class="gaoxiong">
            <div class="taipei-num">
                <i v-on:click="show=!show" class="el-icon-chat-dot-square"></i>
                <transition name="fade">
                    <a href="https://line.me/R/ti/p/%40962ktrrr" v-if="show">@加好友 /LINE</a>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'callphone',
        data() {
            return {
            show: true
            };
        }
    };

</script>
<style lang='scss' scoped>
    .phone-input {
        position: fixed;
        right: 40px;
        bottom: calc(50% - 250px);
        .taipei,.taizhong,.gaoxiong{
            display: flex;
            border: 2px solid #fff;
            border-radius: 5px;
            color: #fff;
            background: #006bb3;
            margin-bottom: 10px;
            padding: 6px 12px;
            transition: .3s;
            &-num{
                display: flex;
                align-items: center;
                font-size: 1rem;
                transition: .3s;
                overflow: hidden;
                cursor:pointer;
                i {
                    font-size: 1.6rem;
                }
                a {
                    color: #fff;
                    margin-left: 8px;
                }
            }
            &:hover{
                background-color: #00a9e0;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to  {
        opacity: 0;

    }
</style>



// WEBPACK FOOTER //
// src/base/callphone/index.vue